import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import _ from 'static/script/libs/underscore';

function EndItem() {

    this.defaultAttrs({
        endItem: '[data-end-item]',
        endItemModal: '[data-modal-end-item]'
    });

    function addQuotes(s) {
        return '"' + s + '"';
    }

    this.getAttribute = function (name) {
        if (!this.node.attributes[name]) {
            return null;
        }
        return this.node.attributes[name].value;
    };

    this.resolveItemIdFromAttribute = function () {
        return this.getAttribute('data-end-item');
    };

    this.resolveItemTitleFromAttribute = function() {
        let result = this.getAttribute('data-end-item-title');
        if (result) {
            result = addQuotes(result);
        } else {
            result = 'annonsen';
        }
        return result;
    };

    this.setItemIdInForm = function(jqueryObject, itemId) {
        jqueryObject.find('[name=itemId]').val(itemId);
    };

    this._unescapeTemplateTags = function(escapedHtml) {
        return escapedHtml.replace('&lt;%=', '<%=').replace('%&gt;', '%>');
    };

    this.getHtmlForModal = function (itemId, itemTitle) {
        let html = $(this.attr.endItemModal).html();
        let template = _.template(html);
        return template(({ itemId: itemId, itemTitle: itemTitle }));
    };

    this._showEndItemModal = function (evt) {
        evt.preventDefault();
        let itemId = this.resolveItemIdFromAttribute();
        let itemTitle = this.resolveItemTitleFromAttribute();
        let modalHtml = this.getHtmlForModal(itemId, itemTitle);
        let payload = {
            content: modalHtml
        };
        this.trigger(document, 'ui:modal:open', payload);
    };

    this.after('initialize', function() {
        this.on('click', {
            endItem: this._showEndItemModal
        });
    });
}

module.exports = defineComponent.component(EndItem);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/end-item.js